import React, { Component } from 'react';
import FlexpassPoster from './FlexpassPoster/FlexpassPoster';
import FlexpassDetails from './FlexpassDetails/FlexpassDetails';
import { SetComponentLanguage } from '../../../helpers';
import moment from 'moment';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Flexpass extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    renderUnavailable = () => {
        let localUTC = moment().utc();
        if(this.props.user.role === 'box-office' || this.props.user.role == 'client'){
            if(localUTC.isAfter(this.props.flexpass.sale_end_box_office)) {
                return (
                    <span className="showtix-badge unavailable position-relative">{strings.notAvailable}</span>
                );
            } else {
                return null;
            }
        } else {
            if(!localUTC.isBetween(this.props.flexpass.sale_start, this.props.flexpass.sale_end) && this.props.flexpass.presale_password === '') {
                return (
                    <span className="showtix-badge unavailable position-relative">{strings.notAvailable}</span>
                );
            } else {
                return null;
            }
        }
    }

    renderUnlock = () => {
        let localUTC = moment().utc();
        if(this.props.flexpass.is_unlocked === true) {
            return (
                <span className="showtix-badge showtix-background__primary-2 position-relative">{strings.unlocked}</span>
            );
        }
        if(this.props.flexpass.presale_password !== "" && localUTC.isBetween(this.props.flexpass.presale_start, this.props.flexpass.presale_end) && this.props.flexpass.is_unlocked !== true){
            if (this.props.user.role === 'client' || this.props.user.role === 'box-office') {
                return null;
            } else {
                return (
                    <button
                        className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                        flexpass_id={this.props.flexpass.id}
                        onClick={this.props.togglePassword}    
                    >
                        {strings.unlock}
                    </button>
                );
            }
        }
    }

    renderButton = () => {
        let localUTC = moment().utc();
        if (this.props.user.role === 'client' || this.props.user.role === 'box-office') {
            if(localUTC.isBefore(this.props.flexpass.sale_end_box_office)) {
                return (
                    <button
                        className="showtix-button showtix-background__primary-2"
                        onClick={() => {
                            this.props.toggleAllCategories();
                            this.props.populateTicketSelection(this.props.flexpass.id, undefined, 'flexpass')
                        }}
                    >{strings.purchase}</button>
                );
            } else {
                return (
                    <button
                        className="showtix-button showtix-background__primary-2"
                        disabled="disabled"
                    >{strings.purchase}</button>
                );
            }
        } else {
            if(localUTC.isBetween(this.props.flexpass.presale_start, this.props.flexpass.presale_end) && this.props.flexpass.is_unlocked) {
                return (
                    <button
                        className="showtix-button showtix-background__primary-2"
                        onClick={() => {
                            this.props.toggleAllCategories();
                            this.props.populateTicketSelection(this.props.flexpass.id, undefined, 'flexpass')
                        }}
                    >{strings.purchase}</button>
                );
            } else {
                if(localUTC.isBetween(this.props.flexpass.sale_start, this.props.flexpass.sale_end)) {
                    return (
                        <button
                            className="showtix-button showtix-background__primary-2"
                            onClick={() => {
                                this.props.toggleAllCategories();
                                this.props.populateTicketSelection(this.props.flexpass.id, undefined, 'flexpass')
                            }}
                        >{strings.purchase}</button>
                    );
                } else {
                    return (
                        <button
                            className="showtix-button showtix-background__primary-2"
                            disabled="disabled"
                        >{strings.purchase}</button>
                    );
                }
            }
        }
    }

    render() { 
        return ( 
            <div className="col-6 col-md-4 col-lg-3">
                <div className="showtix-event showtix-flexpass">
                    <FlexpassPoster
                        user={this.props.user}
                        current_client_id={this.props.current_client_id}
                        flexpass={this.props.flexpass}
                        toggleDetails={this.props.toggleDetails}
                        toggleConfirmDeleteFlexpass={this.props.toggleConfirmDeleteFlexpass}
                        getAccountEventReport={this.props.getAccountEventReport}
                        status={this.props.status}
                    />
                    <div className="showtix-event__dates">
                        {this.renderUnavailable()}
                        {this.renderUnlock()}
                        {this.renderButton()}
                    </div>
                    <FlexpassDetails
                        flexpass={this.props.flexpass}
                        toggleDetails={this.props.toggleDetails}
                    />
                </div>
            </div>
        );
    }
}
 
export default Flexpass;


// WEBPACK FOOTER //
// ./src/components/EventListing/Flexpass/Flexpass.js